import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=e4a96cac&"
import script from "./UserName.vue?vue&type=script&lang=js&"
export * from "./UserName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserName.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/UserName.vue
// module id = 895
// module chunks = 1